import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={FlyoutProductCreationFaqSection.PRODUCT_DETAILS_ACKNOWLEDGMENT}
        question="What are the acknowledgments for? Why do I need to answer them?"
      />
    ),
    answer: (
      <div>
        Acknowledgments confirm that your product listing follows AWS guidelines
        for SaaS products. If your listing does not comply, AWS may{' '}
        <strong>reject it during testing</strong>, delaying its public
        availability. Answering these ensures compliance and smooth approval.
      </div>
    ),
  },
]

interface FlyoutProductDetailsAcknowledgementFaqsProps {
  indexModal?: number
  setIndexModal?: (index: number) => void
}

export const FlyoutProductDetailsAcknowledgementFaqs: React.FC<
  FlyoutProductDetailsAcknowledgementFaqsProps
> = () => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Acknowledgement"
    faqItems={faqItems}
  />
)
